import { AllureWeeklyPlanStateTypes, AllureWeeklyPlanActionTypes } from "./AllureWeeklyPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllureWeeklyPlanStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllureWeeklyPlanReducer = (
  state: AllureWeeklyPlanStateTypes = INITIAL_STATE,
  action: any
): AllureWeeklyPlanStateTypes => {
  switch (action.type) {
    case AllureWeeklyPlanActionTypes.FETCH_ALL_ALLURE_WEEKLY_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureWeeklyPlanActionTypes.FETCH_ALL_ALLURE_WEEKLY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureWeeklyPlanActionTypes.FETCH_ALL_ALLURE_WEEKLY_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureWeeklyPlanActionTypes.FETCH_ALL_ALLURE_WEEKLY_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllureWeeklyPlanActionTypes.FETCH_ONE_ALLURE_WEEKLY_PLAN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureWeeklyPlanActionTypes.FETCH_ONE_ALLURE_WEEKLY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureWeeklyPlanActionTypes.FETCH_ONE_ALLURE_WEEKLY_PLAN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureWeeklyPlanActionTypes.FETCH_ONE_ALLURE_WEEKLY_PLAN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllureWeeklyPlanReducer;
